export function MastheadBar() {
  return <div className="tt-masthead-bar" aria-hidden="true" />;
}
